import { PublicationStatusSchema } from "../solo-cms/publication-status";
import { z } from "zod";

// ====== Response DTO (read) ======

export const HubUpdateDtoSchema = z.object({
  id: z.uuid(),
  title: z.string().min(1),
  description: z.string(),
  link: z.string().nullable().optional(),
  imageFileId: z.uuid().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
  imagePosition: z.string().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
  publishedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type HubUpdateDto = z.infer<typeof HubUpdateDtoSchema>;

// ====== Save DTOs (write) ======

const BaseHubUpdateDtoSchema = z.object({
  title: z.string().min(1),
  description: z.string().min(1),
  link: z.string().nullable().optional(),
  imageFileId: z.uuid().nullable().optional(),
  imagePosition: z.string().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
});

export const CreateHubUpdateDtoSchema = BaseHubUpdateDtoSchema;
export type CreateHubUpdateDto = z.infer<typeof CreateHubUpdateDtoSchema>;

export const UpdateHubUpdateDtoSchema = BaseHubUpdateDtoSchema.extend({
  id: z.uuid(),
});
export type UpdateHubUpdateDto = z.infer<typeof UpdateHubUpdateDtoSchema>;

export const SaveHubUpdateDtoSchema = z.union([UpdateHubUpdateDtoSchema, CreateHubUpdateDtoSchema]);
export type SaveHubUpdateDto = z.infer<typeof SaveHubUpdateDtoSchema>;

// ====== Query params ======

export const GetHubUpdateByIdQueryParamsSchema = z.object({
  hubUpdateId: z.uuid(),
});
export type GetHubUpdateByIdQueryParamsDto = z.infer<typeof GetHubUpdateByIdQueryParamsSchema>;

export const GetHubUpdatesByPageQueryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  search: z.string().optional(),
});
export type GetHubUpdatesByPageQueryParamsDto = z.infer<typeof GetHubUpdatesByPageQueryParamsSchema>;

export const DeleteHubUpdateQueryParamsSchema = z.object({
  hubUpdateId: z.uuid(),
});
export type DeleteHubUpdateQueryParamsDto = z.infer<typeof DeleteHubUpdateQueryParamsSchema>;

// ====== Result schemas ======

export const GetHubUpdatesByPageResultSchema = z.object({
  data: z.array(HubUpdateDtoSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
});
export type GetHubUpdatesByPageResultDto = z.infer<typeof GetHubUpdatesByPageResultSchema>;

export const GetPublishedHubUpdatesResultSchema = z.array(HubUpdateDtoSchema);
export type GetPublishedHubUpdatesResultDto = z.infer<typeof GetPublishedHubUpdatesResultSchema>;
